import { NodeViewWrapper } from "@tiptap/react";
import { useRef } from "react";

export function InlineImageView({ node, updateAttributes, selected }: any) {
  const imgRef = useRef<HTMLImageElement>(null);

  function onMouseDown(e: React.MouseEvent) {
    e.preventDefault();
    e.stopPropagation();

    const startX = e.clientX;
    const startWidth = imgRef.current!.offsetWidth;

    function onMove(ev: MouseEvent) {
      const diff = ev.clientX - startX;
      const newWidth = Math.max(8, startWidth + diff);

      updateAttributes({
        width: newWidth,
        height: newWidth,
      });
    }

    function onUp() {
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onUp);
    }

    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onUp);
  }

  return (
    <NodeViewWrapper
      as="span"
      style={{
        display: "inline-flex",
        alignItems: "center",
        position: "relative",
      }}
    >
      <img
        ref={imgRef}
        src={node.attrs.src}
        alt={node.attrs.alt}
        draggable={false}
        style={{
          width: node.attrs.width,
          height: node.attrs.height,
          cursor: "ew-resize",
          verticalAlign: "middle",
        }}
        onMouseDown={onMouseDown}
      />

      {selected && (
        <span
          style={{
            position: "absolute",
            right: -4,
            bottom: -4,
            width: 8,
            height: 8,
            background: "#6229ff",
            borderRadius: "50%",
            cursor: "ew-resize",
          }}
          onMouseDown={onMouseDown}
        />
      )}
    </NodeViewWrapper>
  );
}
